<template>
  <div class=" mt-2">
    <b-breadcrumb class="breadcrumb-pipes">
      <b-breadcrumb-item href="/settings/admin-panel/">
          Admin Panel
        </b-breadcrumb-item>
        <b-breadcrumb-item href="/settings/user-role">
          Roles and Permissions
        </b-breadcrumb-item>
        <b-breadcrumb-item href="/settings/personal-settings">
          Personal Settings
        </b-breadcrumb-item>
      </b-breadcrumb>

    <b-card
      class="mb-0"
      :title="$t('settings.commission.titles.manage_commissions')"
    >
      <b-overlay :show="loading" rounded="sm" no-fade>
        <div class="m-2">
          <b-row align-h="between">
            <b-col cols="12" md="3">
              <b-form-input
                v-model="filter"
                class="d-inline-block mr-1 mt-1"
                :placeholder="$t('general_text.search_table')"
              />
            </b-col>

        

        
            <b-col v-if="$Can('add_commission')" cols="12" md="3">

           

              <div class="d-flex align-items-center justify-content-end">
              

                <b-button class="mt-1" variant="success" @click="addCostCenter">
                  <span class="text-nowrap">{{
                    $t("settings.commission.buttons.create_new_commission")
                  }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>

        <b-table
          striped
          hover
          ref="refUserListTable"
          class="position-relative p-2"
          :items="allCostCenters"
          :filter="filter"
          filter-debounce="250"
          @filtered="onFiltered"
          :filter-included-fields="filterOn"
          selectable
          select-mode="single"
          responsive
          :small="true"
          head-variant="dark"
          :fields="tableColumns"
          show-empty
          :empty-text="$t('general_messages.no_matching_recors_found')"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template #cell(index)="data">
            <b
              ><span class="font-weight-bold">
                <strong class="text-primary">#{{ data.index + 1 }}</strong>
              </span></b
            >
          </template>
          <!-- Column: CostCenter -->
          <template #cell(AccountName)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.AccountName ? data.item.AccountName : "N/A"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data" v-if="$Can('delete_commission')">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item @click="deleteCommission(data.item)">
                <feather-icon icon="DeleteIcon" />
                <span class="align-middle ml-50"> {{ $t('settings.intermediary.buttons.delete_intermediary') }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("general_text.showing") }} {{ dataMeta.from }}
                {{ $t("general_text.to") }} {{ dataMeta.to }}
                {{ $t("general_text.of") }} {{ dataMeta.of }}
                {{ $t("general_text.entries") }}</span
              >
            </b-col>

            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
      {{ /*commission create modal*/ }}
      <b-modal
        id="modal-prevent-closing"
        v-model="costCenterCreateModal"
        :title="$t('settings.commission.titles.create_new_commission')"
        @hidden="resetCommissionModal"
        size="md"
        ok-title=""
        :ok-title="$t('settings.commission.buttons.create')"
        :cancel-title="$t('settings.commission.buttons.cancel')"
        @ok="createCostCenter"
        no-close-on-backdrop
        
      >
        <b-overlay :show="createCostCenterLoading" rounded="sm" no-fade>
          <b-container>
            <b-form>
              <validation-observer ref="createCostCenterValidation">

              <b-row class="mt-2">
                <b-col cols="12" xl="12" lg="12" md="12" sm="12">
                  <b-form-group label-for="local">
                    <validation-provider
                      name="local"
                      #default="{ errors }"
                      rules="required"
                    >
                      <v-select
                      :placeholder="$t('settings.commission.titles.commission_client')"

                        v-model="commissionClient"
                        :label="$t('settings.commission.titles.commission_client')"
                        id="Locals"
                        :clearable="false"
                        :taggable="false"
                        :options="clients"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="mt-2">
                <b-col cols="12" xl="12" lg="12" md="12" sm="12">
                  <b-form-group label-for="local">
                    <validation-provider
                      name="local"
                      #default="{ errors }"
                      rules="required"
                    >
                      <v-select
                      :placeholder="$t('settings.commission.titles.commission_country')"

                        v-model="commissionCountry"
                        :label="$t('settings.commission.titles.commission_country')"
                        id="Locals"
                        :clearable="false"
                        :taggable="false"
                        :options="countries"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>


              <b-row class="mt-2">
                <b-col cols="12" xl="12" md="12">
                    <!-- commission name -->
                    <b-form-group>
                      <validation-provider
                        #default="{ errors }"
                        :name="
                          $t('settings.commission.titles.commission_rate')
                        "
                        rules="required"
                      >
                        <b-form-input
                          id="commissionname"
                          type="number"
                          min="0"
                          step="any"
                          v-model="commissionRate"
                          name="commission-name"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="
                            $t('settings.commission.titles.commission_rate') + ' (bp)'
                          "
                          @change="checkRate"

                          autofocus
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                </b-col>
              </b-row>            </validation-observer>

            </b-form>
          </b-container>
          <template #overlay v-if="createCostCenterLoading">
            <div
              class="text-center d-flex justify-content-center align-items-start"
            >
              <b-icon icon="stopwatch" font-scale="3" animation="cylon">
              </b-icon>
              <p id="cancel-label">
                <feather-icon icon="DownloadIcon" />
                {{
                  $t(
                    "settings.commission.messages.commission_creating_message"
                  )
                }}
              </p>
            </div>
          </template>
        </b-overlay>
        {{/****END*** commission create modal*/}}
      </b-modal>





      <b-modal
        id="modal-prevent-closing"
        v-model="updateDefaultModal"
        :title="$t('settings.commission.titles.default_commission')"
        @hidden="resetUpdateDefaultModal"
        size="md"
        ok-title=""
        :ok-title="$t('settings.commission.buttons.update')"
        :cancel-title="$t('settings.commission.buttons.cancel')"
        @ok="updateDefault"
      >
        <b-overlay :show="updateDefaultLoading" rounded="sm" no-fade>
          <b-container>
            <b-form>
       
              <validation-observer ref="updateDefaultsValidation">


              <b-row class="mt-2">
                <b-col cols="12" xl="12" lg="12" md="12" sm="12">
                  <b-form-group label-for="local">
                    <validation-provider
                      name="local"
                      #default="{ errors }"
                      rules="required"
                    >
                    Equity Default Cost Center
                      <v-select
                        v-model="equityDefault"
                        id="Locals"
                        :clearable="false"
                        :taggable="false"
                        :options="optEquityDefaults"
                        
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col cols="12" xl="12" lg="12" md="12" sm="12">
                  <b-form-group label-for="local">
                    <validation-provider
                      name="local"
                      #default="{ errors }"
                      rules="required"
                    >
                    Bond Default Cost Center
                      <v-select
                        v-model="bondDefault"
                        id="Locals"
                        :clearable="false"
                        :taggable="false"
                        :options="optBondDefaults"
                        
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col cols="12" xl="12" lg="12" md="12" sm="12">
                  <b-form-group label-for="local">
                    <validation-provider
                      name="local"
                      #default="{ errors }"
                      rules="required"
                    >
                    Fx Default Cost Center
                      <v-select
                        v-model="fxDefault"
                        id="Locals"
                        :clearable="false"
                        :taggable="false"
                        :options="optFXDefaults"
                        
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col cols="12" xl="12" lg="12" md="12" sm="12">
                  <b-form-group label-for="local">
                    <validation-provider
                      name="local"
                      #default="{ errors }"
                      rules="required"
                    >
                    Transfers Default Cost Center
                      <v-select
                        v-model="transferDefault"
                        id="Locals"
                        :clearable="false"
                        :taggable="false"
                        :options="optTransferDefaults"             
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
           
            </validation-observer>

            </b-form>
          </b-container>
          <template #overlay v-if="updateDefaultLoading">
            <div
              class="text-center d-flex justify-content-center align-items-start"
            >
              <b-icon icon="stopwatch" font-scale="3" animation="cylon">
              </b-icon>
              <p id="cancel-label">
                <feather-icon icon="DownloadIcon" />
                {{
                  $t(
                    "settings.commission.messages.commission_creating_message"
                  )
                }}
              </p>
            </div>
          </template>
        </b-overlay>
        {{/****END*** commission create modal*/}}
      </b-modal>

    </b-card>
  </div>
</template>

<script>
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormRating,
  VBModal,
  BTabs,
  BTab,
  BCardText,
  BIcon,
} from "bootstrap-vue";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "../../settingsStoreModule";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, alphaNum, email, min, max } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import axios from "axios";
import axiosIns from "@/libs/axios";
import router from "@/router";
import moment from "moment";
import "animate.css";
import _ from "lodash";
import { mapState, mapGetters } from "vuex";
  import { BBreadcrumb, BBreadcrumbItem } from 'bootstrap-vue'

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BTabs,
    BTab,
    BCardText,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormRating,
    BIcon,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
    BBreadcrumb, BBreadcrumbItem
  },

  directives: {
    Ripple,
    "b-modal": VBModal,
  },

  setup() {
    const SETTINGS_APP_STORE_MODULE_NAME = "settings";
    // Register module
    if (!store.hasModule(SETTINGS_APP_STORE_MODULE_NAME))
      store.registerModule(SETTINGS_APP_STORE_MODULE_NAME, settingsStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SETTINGS_APP_STORE_MODULE_NAME))
        store.unregisterModule(SETTINGS_APP_STORE_MODULE_NAME);
    });
  },

  data() {
    return {
      allCostCenters: [],
      countries: [],
      clients:[],
      defaultRate:null,
      commissionRate: null,
      commissionClient:null,
      commissionCountry:null,
      updateDefaultModal: false,
      updateDefaultLoading: false,
      equityDefault: null,
      bondDefault: null,
      fxDefault: null,
      transferDefault: null,
      optEquityDefaults: [],
      optBondDefaults: [],
      optFXDefaults: [],
      optTransferDefaults: [],


      costCenterCreateModal: false,
      allCreatedCurrencies: [],
      accessLevel: null,
      filterModal: null,
      updatePermloading: false,
      createCostCenterLoading: false,
      newCostCenter: null,

      filterOn: ["Client","Country","Rate"],
      tableColumns: [
        {
          key: "index",
          label: "",
        },
        {
          key: "Client",
          label: this.$t("settings.commission.table.commission_client"),
          sortable: true,
        },
        {
          key: "Country",
          label: this.$t("settings.commission.table.commission_country"),
          sortable: true,
        },
        {
          key: "Rate",
          label: this.$t("settings.commission.table.commission_rate") + " (bp)",
          sortable: true,
          formatter: (value) => (value == null ? "" : Number((value * 10000).toFixed(4))),
        },
        { key: "actions", label:this.$t('settings.commission.table.actions'), sortable: false },
      ],
      perPage: localStorage.getItem("costCenterShow") ?? 10,
      currentPage: 1,
      totalRows: 0,
      perPageOptions: [10, 25, 50, 100],
      filter: null,

      loading: false,
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.getters["authUser"];
      },
      set(newValue) {
        return this.$store.dispatch("setUser", newValue);
      },
    },
    ...mapGetters(["authUser"]),
    dataMeta() {
      return {
        from:
          this.totalRows != 0 ? this.perPage * (this.currentPage - 1) + 1 : 0,
        to:
          this.perPage * (this.currentPage - 1) + Number(this.perPage) <
          this.totalRows
            ? this.perPage * (this.currentPage - 1) + Number(this.perPage)
            : this.totalRows,
        of: this.totalRows,
      };
    },
  },
  mounted() {
    this.getCommissions();
  },
  methods: {

    // Rate is entered in basis points; it is stored as a fraction (4 bp = 0.0004).
    checkRate(){

      if (this.commissionRate < 0) {
        this.commissionRate = 0
      }

      },
      
    checkDefaultRate(){

    if (this.defaultRate < 0) {
      this.defaultRate = 0

    }else if (this.defaultRate > 1) {
      if(this.defaultRate <= 100){
        this.defaultRate = this.defaultRate/100

      }else{
        this.defaultRate = 1

      }
      
    }

    },


    getCommissions() {
      this.loading = true;
      store
        .dispatch("settings/getCommissions", this.user)
        .then((res) => {
          this.allCostCenters = res.data.commissions;
          this.countries = res.data.countries;
          this.clients = res.data.clients;

          this.totalRows = res.data.length;

       


          this.loading = false;

        })
        .catch((error) => {
          this.databaseErrorMessage();
          console.log(error);
        });
    },
    addCostCenter() {
      this.costCenterCreateModal = true;
    },
    createCostCenter(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$refs.createCostCenterValidation.validate().then((success) => {
        if (success) {
          this.createCostCenterLoading = true;
         
                store
                  .dispatch("settings/createCommission", {
                    Rate: this.commissionRate / 10000,
                    Country: this.commissionCountry,
                    Client: this.commissionClient,

                  })
                  .then((res) => {
                    this.createCostCenterLoading = false;
                    this.resetCommissionModal();
                    this.getCommissions();
                    this.createCostCenterToastMessage();
                    this.costCenterLocal =  "Global";

   


                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            })
            .catch((error) => {
              console.log(error);
            });
    },
    resetCommissionModal() {
      this.costCenterCreateModal = false;
      this.allCreatedCurrencies = [];
      this.newCostCenter = null;
      this.createCostCenterLoading = false;
      this.commissionRate=null;
      this.commissionCountry=null;
      this.commissionClient=null;
    },
    deleteCommission(commission) {
      const self = this;

      this.$swal({
        title:
          this.$t("settings.commission.titles.are_you_sure_delete"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t(
          "settings.commission.buttons.yes_delete_it"
        ),
        cancelButtonText: this.$t("settings.commission.buttons.cancel"),
        customClass: {
          confirmButton: "btn btn-success mr-1",
          cancelButton: "btn btn-danger",
          denyButton: "btn btn-primary",
        },
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          self.loading = true;
          store
            .dispatch("settings/deleteCommission", {
              id: commission.id,
            })
            .then((res) => {
              if (res.data == true) {
                self.getCommissions();
                self.loading = false;
                self.$swal.fire({
                  icon: "success",
                  title: self.$t("settings.commission.titles.deleted"),
                  text: self.$t(
                    "settings.commission.messages.commission_has_been_delete"
                  ),
                  showClass: {
                    popup: "animate__animated animate__fadeInDown",
                  },
                });
              } else {
                this.costCenterNotFoundMessage();
                self.loading = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },



    defaultCostCenters() {
      this.updateDefaultModal = true;
    },
    updateDefault(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$refs.updateDefaultsValidation.validate().then((success) => {
        if (success) {
          this.updateDefaultLoading = true;
        
                store
                  .dispatch("settings/updateDefaultCostCenter", {
                    equityDefault: this.equityDefault,
                    bondDefault: this.bondDefault,
                    fxDefault: this.fxDefault,
                    transferDefault: this.transferDefault,
                  })
                  .then((res) => {
                    this.updateDefaultModal = false;
                    this.updateDefaultLoading = false;
                  })
                  .catch((error) => {
                    console.log(error);
                  });
           
        }
      });
    },
    resetUpdateDefaultModal() {
      this.updateDefaultModal = false;
      this.updateDefaultLoading = false;
    },


    databaseErrorMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: this.$t("settings.commission.messages.database_error"),
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    },
    existingCostCenterMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: this.$t("settings.commission.messages.commission_is_exist"),
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    costCenterNotFoundMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: this.$t("settings.commission.messages.commission_not_found"),
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    createCostCenterToastMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Successfully",
          text: this.$t(
            "settings.commission.messages.commission_create_success"
          ),
          icon: "ThumbsUpIcon",
          variant: "success",
        },
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  watch: {
    perPage: {
      handler: function(val, before) {
        localStorage.setItem("costCenterShow", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
